/**
 * 
 * @property {Object} formWrapper - wrapper DOM element
 * @param {Object} formField - DOM element that of the "variant" form field that needs updating on the product form
 * @returns {Function(variantId{String})} function that takes the variant ID and returns an (impure) function that updates the field with the variant id 
 */


const updateVariantFormField = (formWrapper, formField, productHandle, isSecondProduct) => ((variant) => {
  let id = variant ? variant.id : '';
  const variantTitle = variant ? variant.title : '';
  // [data-product-form="${productHandle}"] **specificity**
  
  // always need the id on the wrapper for use in BIS
  formWrapper.dataset.productVar = id 

  if (id && !variant.available) {
    id = '';
  }

  const btn = document.querySelector('[data-product-form-submit]'); 
  if (btn) { !isSecondProduct ? btn.dataset.atcProductId = id : btn.dataset.atcProductIdSecond = id; }
  if (btn) { !isSecondProduct ? btn.dataset.atcProductTitle = variantTitle : btn.dataset.atcProductTitleSecond = variantTitle; }
  formField.value = id
})
export default updateVariantFormField;